import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'

export function DefaultErrorComponent({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation()

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <AlertTriangle className="h-12 w-12 text-amber-500" />
        <h2 className="text-xl font-semibold">{t('common.error.title')}</h2>
        <p className="max-w-md text-muted-foreground">
          {t('common.error.description')}
        </p>
        <Button variant="outline" onClick={reset}>
          <RefreshCw />
          {t('common.actions.retry')}
        </Button>

        {import.meta.env.DEV && error instanceof Error && (
          <pre className="mt-4 max-w-2xl overflow-auto rounded bg-muted p-4 text-left text-xs text-muted-foreground">
            {error.stack ?? error.message}
          </pre>
        )}
      </div>
    </div>
  )
}
